import React, {useCallback} from 'react';

import {PaginationStripe} from '@pb/kit-component-pagination';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

const PAGE_SIZE = 5;

type Props = {
    totalCount: number,
    currentPage: number,
    onPageChange: (page: number) => void,
};

export const McpAlertsPagination = ({totalCount, currentPage, onPageChange}: Props) => {
    const onPaginationChange = useCallback(
        (pagination: Pagination) => {
            onPageChange(pagination.currentPage);
        },
        [onPageChange],
    );

    return (
        <PaginationStripe
            pageSize={PAGE_SIZE}
            totalCount={totalCount}
            currentPage={currentPage}
            onPaginationChange={onPaginationChange}
            showSizeSwitcher={false}
        />
    );
};
